/* RESPONSIBLE TEAM: team-fin-qa */
// Bridge route for QA assigned-reviews React view (inbox)
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import type Session from 'embercom/services/session';
import type RouterService from '@ember/routing/router-service';
import { ReactRoute } from 'embercom/lib/react-route';

class InboxReviewsAssignedRoute extends Route {
  @service declare session: Session;
  @service declare router: RouterService;

  analytics = {
    section: 'inbox',
    place: 'inbox.reviews.assigned',
  };

  beforeModel() {
    if (this.session.teammate.qaRole !== 'qa_manager') {
      this.router.replaceWith('inbox.workspace.reviews.received');
    }
  }

  reactEnabled() {
    return true;
  }
}

export default ReactRoute(InboxReviewsAssignedRoute);
